import * as angular from 'angular';
import { ILogService } from '../../services/data/index';
import { ComponentDefinition } from '../../models';

class LogsDownloadController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;

    static $inject = ['logService'];

    constructor(private _logService: ILogService) {
    }

    download() {
        this.isLoading = true;
        this._logService.download()
            .then(d => window.open(d, '_self'))
            .finally(() => this.isLoading = false);
    }
}

export const wtLogsDownload: ComponentDefinition = {
    componentId: 'wtLogsDownload',
    controller: LogsDownloadController,
    template: require('./logsDownload.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
